import React, {Component} from 'react';
import Swal from 'sweetalert2';
import Axios from 'axios';

import Parse from '../../../Parse';
import Configs from '../../../Configs';

class User extends Component {
    state = {
        
    };

    render() {
        const owner = {...this.props.owner};

        return (
            <div className="User">
                <div className="box box-default">
                    <div className="box-header with-border">
                        <h3 className="box-title">User Information</h3>
                    </div>
                    <div className="box-body">
                        <p>ID: {owner.objectId}</p>
                        <p>Username: {owner.username}</p>
                        <p>Full Name: {owner.fullName}</p>
                    </div>
                </div>
            </div>
        );
    }
}

export default User;